import injectSheet from 'react-jss'
import SearchResultRow from './SearchResultRow'
import styles from './SearchResultRow.styles'

export default injectSheet(styles)(SearchResultRow)
